export const ReportPath = 'https://influence-storage-bucket.s3.ap-southeast-2.amazonaws.com/';
